import React, { useEffect, useState, useContext } from "react";
import { Menu, MenuHandler, MenuList } from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
import ManuInfoOperation from "./ManuInfoOperation";
import * as notifyApi from "../../../service/notifyApi";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { CurrentUserContext } from "../../../App";

function ManuOperation({ menuActive }) {
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [notifyList, setNotifyList] = useState([]);
  const [page, setPage] = useState(1);
  const [getNotificationTotal, setGetNotificationTotal] = useState(
    localStorage.getItem("Notification"),
  );
  const [openModalApprove, setOpenModalApprove] = useState(false);
  const [itemOnClickNotify, setItemOnClickNotify] = useState("");
  const [checkUserAfterLogin, setCheckUserAfterLogin] = useState(
    localStorage.getItem("user"),
  );
  const [new_notify, setNew_nottify] = useState(false);

  const [open, setOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (localStorage.getItem("Notification") === null) {
      setGetNotificationTotal(0);
    } else {
      // console.log(getNotificationTotal)
    }
    getRequestPermission();
  }, [checkUserAfterLogin]);

  const [widtht, setWidth] = useState(0);

  useEffect(() => {
    const updateWindowDimensions = () => {
      const newWidth = window.innerWidth;
      setWidth(newWidth);
      // console.log("updating Width");
    };

    window.addEventListener("resize", updateWindowDimensions);

    return () => window.removeEventListener("resize", updateWindowDimensions);
  }, []);

  useEffect(() => {
    if (widtht > 767) {
      setOpen(false);
    }
  }, [widtht]);

  const getRequestPermission = async () => {
    setLoading(true);
    let res = await notifyApi.getNotification(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res['data'])
        setNotifyList(res["data"]["notification_list"]);
        localStorage.setItem(
          "Notification",
          res["data"]["notification_list"].length,
        );
        setNew_nottify(res["data"]["is_new_badge"]);
      } else if (res["data"]["code"] === 401) {
        setIsMessage({ type: "error", data: "หมดเวลาใช้งาน" });
        localStorage.clear();
        navigate("/login");
        return;
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const setReadNotification = async () => {
    setLoading(true);
    let res = await notifyApi.setReadNotification(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res['data'])
        getRequestPermission();
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  return (
    <nav className="bg-white z-10 fixed top-0 left-0 right-0 md:h-[70px] h-28 w-full shadow-xl rounded-b-3xl flex justify-between items-center">
      {/* logo&appname */}
      <div className="flex">
        <button onClick={() => navigate("/inputdata")}>
          <img
            className="ml-[50px] lg:ml-[30px] md:ml-[20px] sm:ml-0xsm:ml-0 lg:h-[50px] md:h-[20px] sm:h-[10px]"
            src={require("../../../asset/image/logo.svg").default}
            alt=""
          ></img>
        </button>
      </div>
      {/* mobile */}
      <div className="flex justify-end items-center gap-10 invisible text-3xl absolute right-10 top-15 md:visible">
        <ul
          onClick={() => {
            if (new_notify) {
              setReadNotification();
            }
          }}
        >
          <Menu>
            <MenuHandler>
              <button
                onClick={() => {}}
                className="flex h-full outline-none items-center relative"
              >
                <img
                  onClick={() => {
                    setOpen(false);
                  }}
                  className="w-[48px] h-[48px] rounded-full lg:w-[40px] lg:h-[40px]"
                  src="/notify.svg"
                  alt="notify"
                />
                {new_notify ? (
                  <>
                    <div
                      className={`absolute border-[#FFFFFF] border-2 top-[-2px] right-[-3px] lg:top-[-2px] lg:right-[-2px] w-5 h-5 lg:w-4 lg:h-4 text-[0.60rem] leading-tight font-medium rounded-full flex items-center justify-center hover:scale-110 transition-all duration-300 bg-[#EC3B3B] text-[#FFFFFF] `}
                    ></div>
                  </>
                ) : null}
              </button>
            </MenuHandler>
            <MenuList
              className={`flex flex-col ${notifyList.length > 0 ? "mt-7 w-80 rounded-2xl" : "rounded-xl"} z-[19]`}
            >
              <div className="h-full">
                <div
                  className={`${notifyList.length > 3 ? "overflow-y-scroll" : "overflow-hidden"} `}
                >
                  <div
                    className={`${notifyList.length > 3 ? "h-[300px]" : ""} `}
                  >
                    {notifyList.length ? (
                      <>
                        {notifyList.map((i, idx) => (
                          <button
                            key={idx}
                            className="grid py-1 rounded-lg px-[15px] w-full"
                          >
                            <div
                              onClick={() => {}}
                              className="hover:rounded-lg hover:bg-[#fdf4f0] p-[5px]"
                            >
                              <div className="grid grid-cols-[auto_50px] justify-between font-bold py-[5px]">
                                <div>{i["payload"]["topic"]}</div>
                                <div className="text-[#FFC0A4]">
                                  {i["create_date"]["time"]}
                                </div>
                              </div>
                              <div className="text-[#FF9768] flex justify-start py-[5px]">
                                {i["payload"]["detail"]}
                              </div>
                              <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768] mt-[10px]"></div>
                            </div>
                          </button>
                        ))}
                      </>
                    ) : (
                      <div className="text-center text-[#2E2E2E] font-medium">
                        ไม่พบการแจ้งเตือน
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </MenuList>
          </Menu>
        </ul>
        <ul>
          <Menu open={open}>
            <MenuHandler>
              <div>
                {open ? (
                  <XMarkIcon
                    onClick={() => setOpen(!open)}
                    className="w-6 stroke-[#FF9768] stroke-[3px]"
                  />
                ) : (
                  <Bars3Icon
                    onClick={() => setOpen(!open)}
                    className="w-6 stroke-[#FF9768] stroke-[3px]"
                  />
                )}
              </div>
            </MenuHandler>
            <MenuList className="flex flex-col items-center md:gap-y-2 gap-y-5 md:h-auto h-[510px] rounded-3xl ">
              <div
                onClick={() => navigate("/laboratory/home")}
                className={`text-md ${menuActive === "homeoperation" ? "text-[#FF9768] font-bold" : "text-[#000000]"}`}
              >
                หน้าหลัก
              </div>
              <div
                onClick={() => navigate("/inputdata")}
                className={`text-md ${menuActive === "inputdata" ? "text-[#FF9768] font-bold" : "text-[#000000]"}`}
              >
                ข้อมูลผลการตรวจ
              </div>
              <div
                onClick={() => navigate("/inspectionGuide")}
                className={`text-md ${menuActive === "inspectionGuide" ? "text-[#FF9768] font-bold" : "text-[#000000]"}`}
              >
                แนวทางการตรวจ
              </div>
              <div
                onClick={() => navigate("/laboratory/relatedinfo")}
                className={`text-md ${menuActive === "relatedinfo" ? "text-[#FF9768] font-bold" : "text-[#000000]"}`}
              >
                ข้อมูลที่เกี่ยวข้อง
              </div>
              <div
                onClick={() => navigate("/laboratory/ans")}
                className={`text-md ${menuActive === "ans" ? "text-[#FF9768] font-bold" : "text-[#000000]"} `}
              >
                คำถามที่พบบ่อย
              </div>
              <div
                onClick={() => navigate("/laboratory/contact")}
                className={`text-md ${menuActive === "contact" ? "text-[#FF9768] font-bold" : "text-[#000000]"} `}
              >
                ติดต่อเรา
              </div>
              <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768]"></div>
              <div className="flex flex-col gap-3 justify-center items-center">
                <img
                  className={
                    user?.profile_image
                      ? "w-[48px] h-[48px] lg:w-[30px] lg:h-[30px] rounded-full"
                      : "w-[48px] h-[48px] lg:w-[30px] lg:h-[30px]"
                  }
                  src={
                    user?.profile_image
                      ? user?.profile_image
                      : require("../../../asset/icon/iconuser.svg").default
                  }
                  alt="iconuser"
                />
                <p className="text-[#FF9768] text-lg font-medium px-3 lg:text-xs">
                  {user?.fname + " " + user?.lname}
                </p>
              </div>

              <div className="flex flex-col items-center gap-y-2 md:w-full">
                <div
                  onClick={() => {
                    navigate("/manageprofileOperation");
                  }}
                  className="md:w-full text-center button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]"
                >
                  จัดการข้อมูลส่วนตัว
                </div>
                {user["auth"]["role"][0] === "LABORATORY_PERSONNEL" ? null : (
                  <div
                    onClick={() => {
                      navigate("/manageUsersOperation");
                    }}
                    className="md:w-full text-center button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]"
                  >
                    สิทธิ์การเข้าถึงข้อมูล
                  </div>
                )}
                <div
                  onClick={() => {
                    navigate("/laboratory/changepassword");
                  }}
                  className="md:w-full text-center button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]"
                >
                  เปลี่ยนรหัสผ่าน
                </div>
                <div
                  onClick={() => {
                    navigate("/laboratory/about");
                  }}
                  className="md:w-full text-center button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]"
                >
                  เกี่ยวกับเรา
                </div>
              </div>

              <div
                onClick={() => {
                  localStorage.clear();
                  navigate("/login");
                }}
                className="flex justify-center items-center bg-white rounded-full w-[120px] md:w-full h-[25px] ring-1 ring-[#FF9768]"
              >
                <img
                  src={require("../../../asset/icon/logout.svg").default}
                  alt=""
                  className="mr-2 w-[12px]"
                />
                <p className="text-[#FF9768] text-xs">ออกจากระบบ</p>
              </div>
            </MenuList>
          </Menu>
        </ul>
      </div>

      {/* web */}
      <ul className="h-12 flex items-center md:hidden">
        {/* หน้าหลัก */}
        <li>
          <button
            onClick={() => navigate("/laboratory/home")}
            className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${menuActive === "homeoperation" ? "text-[#FF9768] font-bold" : "text-[#000000]"} hover:text-[#FF9768]`}
          >
            หน้าหลัก
          </button>
        </li>
        {/* ข้อมูลผลการตรวจ */}
        <li>
          <button
            onClick={() => navigate("/inputdata")}
            className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${menuActive === "inputdata" ? "text-[#FF9768] font-bold" : "text-[#000000]"} hover:text-[#FF9768]`}
          >
            ข้อมูลผลการตรวจ
          </button>
        </li>
        {/* แนวทางการตรวจ */}
        <li>
          <button
            onClick={() => navigate("/inspectionGuide")}
            className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${menuActive === "inspectionGuide" ? "text-[#FF9768] font-bold" : "text-[#000000]"} hover:text-[#FF9768]`}
          >
            แนวทางการตรวจ
          </button>
        </li>
        {/* ข้อมูลที่เกี่ยวข้อง */}
        <li>
          <button
            onClick={() => navigate("/laboratory/relatedinfo")}
            className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${menuActive === "relatedinfo" ? "text-[#FF9768] font-bold" : "text-[#000000]"} hover:text-[#FF9768]`}
          >
            ข้อมูลที่เกี่ยวข้อง
          </button>
        </li>
        {/* คำถามที่พบบ่อย */}
        <li>
          <button
            onClick={() => navigate("/laboratory/ans")}
            className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${menuActive === "ans" ? "text-[#FF9768] font-bold" : "text-[#000000]"} hover:text-[#FF9768]`}
          >
            คำถามที่พบบ่อย
          </button>
        </li>
        {/* ติดต่อเรา */}
        <li>
          <button
            onClick={() => navigate("/laboratory/contact")}
            className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${menuActive === "contact" ? "text-[#FF9768] font-bold" : "text-[#000000]"} hover:text-[#FF9768]`}
          >
            ติดต่อเรา
          </button>
        </li>
        {/* เเจ้งเตือน */}
        <li
          onClick={() => {
            if (new_notify) {
              setReadNotification();
            }
          }}
        >
          <Menu>
            <MenuHandler>
              <button
                onClick={() => {}}
                className="flex h-full outline-none items-center mr-3 relative"
              >
                <img
                  className="w-[48px] h-[48px] rounded-full lg:w-[30px] lg:h-[30px]"
                  src="/notify.svg"
                  alt="notify"
                />
                {new_notify ? (
                  <>
                    <div
                      className={`absolute border-[#FFFFFF] border-2 top-[-2px] right-[-3px] lg:top-[-2px] lg:right-[-2px] w-5 h-5 lg:w-3 lg:h-3 text-[0.65rem] leading-tight font-medium rounded-full flex items-center justify-center cursor-pointer hover:scale-110 transition-all duration-300 bg-[#EC3B3B] text-[#FFFFFF]`}
                    ></div>
                  </>
                ) : null}
              </button>
            </MenuHandler>
            <MenuList
              className={`flex flex-col ${notifyList.length > 0 ? "mt-7 w-80 rounded-2xl" : "rounded-xl"} z-[19]`}
            >
              {/* <div className='hover:cursor-pointer'>
                                    <div className='flex justify-center items-center gap-5'>
                                        <img className='w-10' src={require('../../../asset/icon/iconuser.svg').default} alt='' />
                                        <div className='text-[#2E2E2E] font-medium'>นาย กกกกก ขขขขขขข</div>
                                        <div className='text-[#FFC0A4]'>เวลา</div>

                                    </div>
                                    <div className='flex justify-center items-center gap-5'>
                                        <div className='text-[#FF9768]'>{'รายละเอียดแจ้งเตือน...'}</div>
                                        <div className=''>{'icon'}</div>
                                    </div>
                                </div> */}
              <div className="h-full">
                <div
                  className={`${notifyList.length > 3 ? "overflow-y-scroll" : "overflow-hidden"} `}
                >
                  <div
                    className={`${notifyList.length > 3 ? "h-[300px]" : ""} `}
                  >
                    {notifyList.length ? (
                      <>
                        {notifyList.map((i, idx) => (
                          <button
                            key={idx}
                            className="grid py-1 rounded-lg px-[15px] w-full"
                          >
                            <div
                              onClick={() => {}}
                              className="hover:rounded-lg hover:bg-[#fdf4f0] p-[5px]"
                            >
                              <div className="grid grid-cols-[auto_50px] justify-between font-bold py-[5px]">
                                <div>{i["payload"]["topic"]}</div>
                                <div className="text-[#FFC0A4]">
                                  {i["create_date"]["time"]}
                                </div>
                              </div>
                              <div className="text-[#FF9768] flex justify-start py-[5px]">
                                {i["payload"]["detail"]}
                              </div>
                              <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768] mt-[10px]"></div>
                            </div>
                          </button>
                        ))}
                      </>
                    ) : (
                      <div className="text-center text-[#2E2E2E] font-medium">
                        ไม่พบการแจ้งเตือน
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </MenuList>
          </Menu>
        </li>
        {/* ข้อมูลส่วนตัว */}
        <li>
          <ManuInfoOperation />
        </li>
      </ul>
    </nav>
  );
}
export default ManuOperation;
